import { Typography, Tooltip } from '@mui/material';
import React from 'react';
import HelpMenuUserGuide from 'types/entities/HelpMenuUserGuide';

const DescriptionCell = React.memo((row: HelpMenuUserGuide) => (
  <Tooltip arrow title={row?.description ?? ''}>
    <Typography noWrap variant="body2">
      {row?.description ?? ''}
    </Typography>
  </Tooltip>
));

export default DescriptionCell;
